module.exports = __webpack_public_path__ + "static/media/add-user-icon-activated.ca35e4ff.png";